import React from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Testimonials from './components/Testimonials'
import Demo from './components/Demo'
import Footer from './components/Footer'


function App() {
 
  return (
    <div>
     
      <Navbar />
      <Hero />
      <hr></hr>
      <About />
      <hr></hr>
      <Testimonials />
      <hr></hr>
      <Demo />
      <hr></hr>
      <Footer />
      
    </div>
  );
}

export default App;
